export default {
  refund: {
    drawerTitle: 'Refund to customer',
    drawerTitleFa: 'استرداد پول',
    menuTitle: 'Refund to customer',
    menuSubtitle: 'استرداد پول به مشتری',
    accessDenied: 'You do not have permission to refund customers.',
    retryQueued: 'QuickBooks refund re-sent',
    close: 'Close',
    posted: 'Posted',
    // Customer
    searchCustomerPlaceholder: 'Search customer by name, username, phone or contract…',
    searching: 'Searching…',
    typeTwoChars: 'Type at least 2 characters',
    noCustomerFound: 'No customer found.',
    pickCustomer: 'Pick the customer who gets the money back',
    change: 'Change',
    balance: 'Balance',
    balanceCredit: 'credit',
    balanceOwes: 'owes',
    balanceSettled: 'settled',
    loadingSources: 'Reading payments and invoices from QuickBooks…',
    tryAgain: 'Try again',
    emptyTitle: 'Nothing to refund for this customer',
    emptyDesc: 'No payment in the last {days} days has money left to return. A refund can only come from money the customer has actually paid.',
    searchOlder: 'Search older payments',
    loadMetaFailed: 'Could not load locations and classes from QuickBooks',
    // Transaction details
    detailsTitle: 'Transaction details',
    detailsTitleFa: 'مشخصات ترانزکشن',
    edit: 'Edit',
    done: 'Done',
    fixDateFirst: 'Fix the date first',
    branch: 'Branch',
    date: 'Date',
    formNo: 'Form no.',
    formNext: 'next',
    formAssigned: '✓ assigned',
    location: 'Location',
    className: 'Class',
    pickLocation: 'Pick a location',
    pickClass: 'Pick a class',
    dateToday: '{solar} · today',
    dateBackDated: '{solar} · back-dated · explain in the note',
    dateErrPick: 'Pick a date',
    dateErrFuture: 'Date is in the future',
    dateErrClosed: 'Books closed until {date}',
    dateErrCashDay: 'Cash day {date} is closed',
    flagDateProblem: 'Date problem',
    flagBackDated: 'Back-dated',
    // 1 · Refund check
    checkTitle: '1 · Refund check',
    checkTitleFa: 'پولی که به مشتری برمی‌گردد',
    checkBadge: 'Expense on A/R',
    fromPayment: 'From payment',
    payOnNone: 'Not applied to any invoice · customer credit',
    payOnSplit: '{applied} on {doc} · {free} extra',
    payOn: 'On {doc}',
    payOnNext: 'On {doc} (not started)',
    payOnOpen: 'Not applied · {doc} still open',
    figExtra: 'extra · up to {max}',
    figRefunded: '{amount} already refunded',
    figRefundable: 'refundable',
    noCashBack: 'No cash goes back',
    noCashBackFa: 'پولی پس داده نمی‌شود',
    amount: 'Amount',
    amountAria: 'Refund amount',
    af: 'Af',
    max: 'Max',
    paidFrom: 'Paid from · cash account',
    pickCashAccount: 'Pick a cash account',
    note: 'Note',
    required: 'required',
    notePh: 'What happened and who approved it',
    notePhPaid: 'e.g. fibre cut since 09/25, 20 days unused',
    notePhCredit: 'e.g. installation not possible at this address',
    notePhOverpaid: 'e.g. paid 3,000 for a 2,300 invoice',
    notePhCredited: 'e.g. moved abroad before activation',
    notePhUsed: 'e.g. never activated, customer cancelled',
    notePhOpen: 'e.g. line never installed',
    notePhNext: 'e.g. paid twice for the same month',
    notePhItems: 'e.g. router returned unopened',
    // 2 · Invoice credit
    appliedAuto: 'Applied automatically · zero payment',
    invoiceTitle: '2 · Invoice credit',
    invoiceTableAria: 'Invoice and its credit',
    invoice: 'Invoice',
    total: 'Total',
    paid: 'Paid',
    open: 'Open',
    amountCol: 'Amount',
    nowPartlyPaid: 'Partly paid',
    nowOpen: 'Open',
    nowPaid: 'Paid',
    crKindMemo: 'Credit Memo',
    crKindNone: 'No credit',
    crTitleUnchanged: 'Invoice not changed',
    crTitleAllItems: 'All items',
    crTitleSomeItems: '{n} of {total} items',
    crTitleFull: 'Full credit',
    crTitlePartial: 'Partial credit',
    crSubDueAgain: 'Due again {due}',
    crSubWillOwe: 'Customer will owe {amount}',
    crSubStaysOpen: 'Stays open',
    crSubNothing: 'Nothing credited',
    crSubToStock: 'Equipment goes back to stock',
    crSubUnusedItems: 'Unused items',
    crSubWhole: 'Whole unused amount',
    crSubPart: '{cm} of {max} Af',
    afterOpen: 'Open {amount} · owes',
    afterPaidUnchanged: 'Paid · unchanged',
    afterFullyCredited: 'Fully credited',
    afterPaidCredited: 'Paid · {amount} credited',
    afterClosed: 'Closed',
    afterDue: 'Due {due}',
    afterDueAmount: 'Due {due} · {amount}',
    afterCancelled: 'Cancelled',
    totalRefundOut: 'Total Refund Out',
    decisionTitle: 'What to do with this invoice?',
    decFull: 'Full credit',
    decPartial: 'Partial credit',
    decNone: 'No change',
    decFullSub: 'Credit {amount} Af',
    decFullSubCloses: 'Credit {amount} Af · closes it',
    decFullSubCancels: 'Credit {amount} Af · cancels it',
    decPartialSub: 'Enter the unused part',
    decPartialSubItems: 'Tick unused items',
    decNoneSubOwe: 'Customer will owe it',
    decNoneSubOpen: 'Stays open',
    decNoneSubDue: 'Due again {due}',
    decNoneSubNothing: 'Nothing is refunded',
    creditAmountLabel: 'Credit amount · unused service (Af)',
    crHelpNegative: 'Credit can’t be negative',
    crHelpOver: 'More than {max} Af',
    crHelpMax: 'Max {max} Af',
    unusedItems: 'Unused items',
    backToStock: 'back to stock',
    // Steps
    stepCreditMemo: 'Credit Memo',
    stepExpense: 'Expense',
    stepZeroPayment: 'Zero payment',
    stepToStock: ' · equipment to stock',
    stepExpenseSub: 'A/R · {account} · {location} · {class}',
    stepZeroTitle: '0 Af · applies {n}',
    stepZeroSubEmpty: 'Applies the documents',
    linkCmInv: 'CM → {doc}',
    linkCmExp: 'CM → Expense',
    linkPayExp: '{pay} → Expense',
    linkPayExpOff: '{pay} → Expense (off {doc})',
    // Footer
    toContinue: 'To continue: {missing}',
    missNegative: 'amount can’t be negative',
    missAmount: 'enter an amount',
    missTickItem: 'tick an item',
    missAmountHigh: 'amount too high',
    missNotEnoughCash: 'not enough cash',
    missNote: 'add a note',
    missCreditHigh: 'credit too high',
    missCreditNegative: 'credit can’t be negative',
    missNothing: 'nothing to record',
    missLocation: 'pick a location',
    missClass: 'pick a class',
    missCashAccount: 'pick a cash account',
    missCustomer: 'pick a customer',
    ctaNothing: 'Nothing to record',
    ctaSaveCredit: 'Save invoice credit',
    ctaRefund: 'Refund {amount} Af',
    printVoucher: 'Print voucher',
    printVoucherTitle: 'Print the refund voucher for the customer to sign',
    printed: 'Printed ✓ · reprint',
    printStale: 'Reprint · details changed',
    printFailed: 'Could not print the voucher',
    recordedInQbo: 'Recorded in QuickBooks',
    savedQboFailed: 'Saved in the cash book · QuickBooks: {error} — retry from the ledger row',
    savedQboPending: 'Saved in the cash book · QuickBooks sync pending',
    // Confirm
    confirmTitleRefund: 'Refund {amount} Af to {customer}',
    confirmTitleCredit: 'Credit {amount} Af on {doc}',
    confirmSub: 'QuickBooks will record:',
    partCheck: '1 · Refund check',
    partInvoice: '2 · Invoice',
    partInvNone: 'No invoice involved',
    partInvCredit: 'Credit Memo · {doc}',
    partInvNoChange: 'No change · {doc}',
    handed: 'Cash handed and receipt signed',
    back: 'Back',
    confirm: 'Confirm',
    confirmAndRefund: 'Confirm & refund',
    toastPosted: 'Refund {ref} posted ✓',
    toastCredit: 'Invoice credit {ref} saved ✓',
    toastQboFailed: 'QuickBooks sync failed — retry from the ledger row',
    postFailed: 'Failed to post the refund.'
  },
  title: 'Payments',
  hotspot: {
    title: 'Hotspot Payment',
    searchPlaceholder: 'Search reseller customers by display name or parent ref...',
  },
  list: {
    title: 'Payments List',
    addPayment: 'Add Payment',
    noPayments: 'No payments found',
    searchCustomers: 'Search by name, username, phone, or contract ID...',
    selectCustomer: 'Select a customer',
    unknownBusiness: 'Unknown Business',
    unknownCustomer: 'Unknown Customer',
    resetFilter: 'Reset customer filter',
    transactionType: 'Transaction Type',
    allTransactions: 'All',
    invoicesOnly: 'Invoices',
    paymentsOnly: 'Payments',
    dateFilter: {
      label: 'Date',
      placeholder: 'Date range',
      from: 'From',
      to: 'To',
      options: {
        all: 'All',
        today: 'Today',
        thisWeek: 'This Week',
        specific: 'Specific date',
        custom: 'Custom',
      },
    },
    columns: {
      id: 'ID',
      date: 'Date',
      customer: 'Customer',
      amount: 'Amount',
      status: 'Status',
      referenceNo: 'Reference No',
      balance: 'Balance',
      type: 'Type',
      actions: 'Actions'
    },
    types: {
      invoice: 'Invoice',
      payment: 'Payment'
    },
    loading: 'Loading...',
    loadingPayments: 'Loading transactions...'
  },
  search: {
    title: 'Search Customers',
    placeholder: 'Search by name, username, phone, or contract ID',
    error: 'Search Error',
    noResults: 'No customers found',
    results: 'Search Results',
    startSearching: 'Enter name, username, phone number, or contract ID to search',
    minChars: 'Please enter at least 3 characters to search',
    columns: {
      name: 'Customer Name',
      email: 'Email',
      phone: 'Phone',
      actions: 'Actions'
    }
  },
  actions: {
    pay: 'Pay'
  },
  form: {
    searchCustomer: 'Search Customer',
    searchPlaceholder: 'Type name, username, phone, or contract ID (min. 3 characters)',
    selectedCustomer: 'Selected Customer',
    amount: 'Amount',
    paymentMethod: 'Payment Method',
    date: 'Payment Date',
    notes: 'Notes',
    error: 'Payment Error',
    selectCustomer: 'Please select a customer first',
    success: 'Payment saved successfully'
  },
  methods: {
    cash: 'Cash',
    card: 'Card',
    bank: 'Bank Transfer'
  },
  status: {
    completed: 'Completed',
    pending: 'Pending',
    failed: 'Failed'
  },
  edit: {
    title: 'Edit Payment'
  },
  create: {
    title: 'New Payment'
  },
  depositTo: {
    title: 'Deposit To',
    cash: 'Cash',
    bank: 'Bank Transfer'
  },
  common: {
    list: 'P',
    select: 'Select...',
    clear: 'Clear',
    change: 'Change',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    view: 'View',
    submitting: 'Submitting...',
    success: 'Success',
    error: 'Error',
    info: 'Info',
    loading: 'Loading...',
    ok: 'OK',
    yes: 'Yes',
  },
  receive: {
    title: 'Receive Payment',
    customerInfo: 'Customer Information',
    summary: 'Summary',
    openBalance: 'Open Balance',
    overduePayment: 'Overdue Payment',
    transactionList: 'Transaction List',
    serviceDetails: 'Service Details',
    quickbooksBalance: 'QuickBooks Balance',
    deltasibBalance: 'DeltaSIB Balance',
    package: 'Package',
    price: 'Price',
    startDate: 'Start Date',
    endDate: 'End Date',
    addService: 'Add Service',
    cancelService: 'Cancel Service',
    startNextService: 'Start Next Service',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspended',
    changeStatus: 'Change Status',
    customerName: 'Customer Name',
    customerId: 'Contract ID',
    selectCustomer: 'Select a customer',
    customerSelected: 'Customer selected',
    contractIdPlaceholder: 'Contract ID',
    paymentDate: 'Payment Date',
    referenceNo: 'Reference No',
    depositTo: 'Deposit To',
    amount: 'Amount',
    paidAmount: 'Paid Amount',
    packageNo: 'Package No',
    memo: 'Memo',
    saveAndPrint: 'Save & Print',
    saveAndClose: 'Save & Close',
    selectDepositAccount: 'Select Deposit Account',
    searchDepositAccount: 'Search deposit account...',
    noDepositAccountsFound: 'No deposit accounts found',
    noBranchDepositAccounts: 'No deposit accounts assigned to your branch',
    usageStats: {
      used: 'Used',
      remaining: 'Remaining',
      unlimited: "Unlimited",
      days: 'Days',
      expired: 'Expired'
    },
    devices: 'Devices',
    quantity: 'Quantity',
    unitPrice: 'Unit Price',
    totalAmount: 'Total',
    deviceDetails: 'Device Details',
    servicePayment: 'Service Payment',
    devicePayment: 'Device Payment',
    mixedPayment: 'Mixed Payment (Service + Device)',
    items: 'Inventory Items',
    paymentHistory: 'Payment History',
    totalToBePaid: 'Total To Be Paid',
    remainingBalance: 'Remaining Balance',
    description: 'Description',
    dueDate: 'Due Date',
    unappliedPayment: 'Unapplied Payment',
    availableAmount: 'Available Amount',
    autoApplyNote: 'This will be automatically applied to selected invoice',
    autoApplied: 'Auto Applied',
    amountAdjusted: 'Amount adjusted to remaining balance',
    customerNotFound: 'Customer not found',
    invalidAmount: 'Please enter a valid amount',
    paymentSuccess: 'Payment recorded successfully',
    depositSuccess: 'Deposit recorded successfully',
    invoiceNotFound: 'Invoice not found',
    // Service management translations
    selectPackage: 'Select Package',
    selectPackageDescription: 'Choose a service package to add to this customer',
    searchPackages: 'Search packages...',
    searchByNameOrId: 'Search by name or service ID...',
    noServicesFound: 'No services found matching your search',
    noServicesAvailable: 'No services available',
    noDescription: 'No description available',
    serviceId: 'Service ID',
    type: 'Type',
    perMonth: 'per month',
    failedToLoadServices: 'Failed to load services',
    serviceAddedSuccessfully: 'Package added successfully',
    failedToAddService: 'Failed to add service',
    serviceRestartedSuccessfully: 'Next package started successfully',
    serviceAlreadyActive: 'This package is already active (started by the system or a previous action).',
    failedToRestartService: 'Failed to restart service',
    serviceCanceledSuccessfully: 'Service canceled successfully',
    failedToCancelService: 'Failed to cancel service',
    noActiveServiceSelectNew: 'No active service found. Please select a new service to activate.',
    noActiveServiceToRestart: 'There is no active service to restart. Please select a service to activate.',
    amountReceived: 'Amount Received',
    amountApplied: 'Amount Applied',
    amountCredit: 'Amount Credit',
    printMemo: 'Print Memo',
    addPendingService: 'Add Service',
    addPendingServiceDescription: 'Add a service package for this customer',
    pendingServiceAddedSuccessfully: 'Service added successfully',
    failedToAddPendingService: 'Failed to add service',
    selectCustomerFirst: 'Please select a customer first',
    rechargeService: 'Recharge',
    rechargeServiceDescription: 'Recharge with the last used service package',
    serviceRechargedSuccessfully: 'Package recharged successfully',
    failedToRechargeService: 'Failed to recharge service',
    noServiceHistoryFound: 'No service history found. Please use "Add Service" to select a package.',
    noPendingServicesToActivate: 'No pending services found. Please add a service first.',
    startNextServiceConfirm: 'This will start "{name}". Do you want to continue?',
    serviceChange: {
      checking: 'Checking current package and QBO invoice…',
      noQboCustomer: 'This customer is not linked to QuickBooks.',
      noActivePackage: 'No active package found in DeltaSIB for this user.',
      originalPrice: 'Original price',
      returnPrice: 'Return price',
      packageFinished: 'This package is finished (volume or duration exhausted).',
      qboInvoiceFound: 'QBO invoice found: {doc}',
      qboInvoiceNotFound: 'No QBO invoice found for this service base.',
      qboInvoiceTotal: 'QBO invoice total',
      qboInvoiceBalance: 'QBO balance',
      qboInvoiceAfterCancel: 'QBO invoice after cancel',
      packageTypeVolume: 'Volume (GB)',
      packageTypeDuration: 'Duration (days)',
      packageTypeVolumeDuration: 'Volume + duration',
      usageVolume: 'Used {used}GB / {total}GB · Remaining {remain}GB',
      usageDays: 'Used {used} / {total} days · Remaining {remain} days',
      previewFailed: 'Failed to load package preview',
      missingDeltaUser: 'DeltaSIB user id is missing for this customer.',
      tableTotal: 'Total',
      tableUsed: 'Used',
      tableOriginalPrice: 'Original price',
      tableReturnPrice: 'Return price',
      tableUsedCost: 'Used cost',
      cancelRefundNote: 'A CancelService refund payment will be created for the current active package.',
      newPackageCardTitle: 'New package',
     pendingOnlyTitle: 'اضافه کردن بسته جدید در حالت انتظار',
      pendingOnlyHint: 'یک بسته جدید به حالت انتظار اضافه می‌شود تا پس از اتمام بسته فعلی آغاز شود. بسته فعالِ کنونی بدون تغییر باقی مانده و کنسل نمی‌شود.',
      replacePackageCardTitle: 'Replace active package',
      currentServiceKeptBanner: 'The current active package will stay active. The new package is added as pending in the queue.',
      dialogDescriptionPendingOnly: 'Select a new package. It will be added as pending without changing the current active service.',
      currentActivePackage: 'Current active package',
      unfinishedServiceBanner: 'This customer still has an active package that is not finished.',
      unfinishedServiceDetail: 'Volume or time is still remaining on the current service.',
      willBeCanceledBanner: 'When you continue, this package will be canceled (status → Cancel) before the new package is added.',
      badgeActive: 'Active',
      badgeNotFinished: 'Not finished',
      badgeWillCancel: 'Will be canceled',
      dialogDescriptionWithCancel: 'Select a new package below. The current active package will be canceled first.',
      noUnfinishedToCancel: 'No unfinished active package — only the new package will be added.',
      activePackageAlreadyFinished: 'The current active package is already finished — it will not be canceled.',
      finishedPackageBanner: 'The current package is finished or expired. Use Add and active — a pending package would be auto-activated by the system within a few minutes.',
      badgeFinished: 'Finished',
      dialogDescriptionFinishedRecharge: 'Select a package to add and activate immediately. The finished package will not be canceled.',
      applyInBalance: 'محاسبه مصرف',
      applyInBalanceHint: 'هزینه بسته فعلی بر اساس میزان حجم و مدت زمان استفاده‌شده محاسبه و کسر می‌گردد. مبلغ باقی‌مانده به بیلانس مشترک افزوده شده، بسته فعلی کنسل و بسته جدید آغاز می‌شود.',
     forceCancel: 'لغو اجباری',
      forceCancelHint: 'بسته فعلی بدون کسر هیچ هزینه‌ای کنسل شده و کل مبلغ مسترد میگردد؛ سپس بسته جدید آغاز می‌شود.',
      forceCancelNotAllowed: 'Force cancel is only available when used cost is below {max} (current used cost: {amount}).',
      addAsPending: 'Add as pending',
      addAndActive: 'Add and active',
      pendingSuccess: 'Service added as pending successfully',
      activatedSuccess: 'Service changed and activated successfully',
      changeFailed: 'Failed to change service package',
    },
  },
  print: {
    paymentReceipt: 'Payment Receipt',
    invoiceReceipt: 'Invoice Receipt',
    button: 'Print Receipt',
    paymentDetails: 'Payment Details',
    paymentDate: 'Payment Date',
    memo: 'Memo',
    companyName: 'Your Company Name',
    receiptTitle: 'Received From',
    dateReceived: 'Date',
    receiptNumber: 'Receipt Number',
    amount: 'Amount',
    customerDetails: 'Customer Details',
    customerName: 'Customer Name',
    servicesProducts: 'Services / Products',
    packageOrService: 'Package / Service',
    activeServiceId: 'Service ID',
    description: 'Description',
    noDescription: 'No Description',
    subtotal: 'Subtotal',
    amountPaid: 'Amount Paid',
    remainingBalance: 'Remaining Balance',
    paymentHistory: 'Payment History',
    createdBy: 'Created by',
    dateTimeCreated: 'Date & Time Created',
    thankYou: 'Thank you for your business!'
  },
  deltaSibStatus: {
    openButton: 'DeltaSIB status',
    title: 'DeltaSIB / VISP',
    tabVisp: 'VISP',
    tabStatus: 'Status',
    currentVisp: 'Current VISP',
    currentStatus: 'Current status',
    setVisp: 'Change VISP',
    setStatus: 'Change status',
    apply: 'Apply',
    vispHint: 'Updates VISP via the API; header refreshes after save.',
    statusHint: 'Uses the DeltaSIB status API (same idea as the legacy client).',
    error: 'Status error',
    missingSelection: 'Select a status first.',
    missingVisp: 'Select a VISP first.',
    statusUpdated: 'Status updated successfully.',
    vispUpdated: 'VISP updated successfully.',
    needLinkedUser: 'Select a customer linked to DeltaSIB.',
    triggerVispPrefix: 'VISP:',
    triggerStatusPrefix: 'Status:',
    openVispDialog: 'Open VISP settings',
    openStatusDialog: 'Open status settings',
    statusEnable: 'Enable',
    statusDisable: 'Disable'
  },
  transfer: {
    drawerTitle: 'Cash transfer',
    drawerSub: 'Moves cash from {from} to {to} · {method}',
    methodSarrafi: 'Cash through a sarrafi',
    methodHand: 'Cash by hand',
    draft: 'Draft',
    inTransit: 'In transit',
    received: 'Received',
    from: 'FROM',
    to: 'TO',
    leavesNow: 'Leaves now',
    left: 'Left',
    onConfirm: 'On confirmed receipt',
    arrived: 'Arrived',
    amountToTransfer: 'Amount to transfer',
    sendAll: 'Send all',
    transferDate: 'Transfer date',
    refNo: 'Reference No.',
    auto: 'Auto',
    howMoneyMoving: 'How is the money moving?',
    throughSarrafi: 'Through a sarrafi (hawala)',
    handCarry: 'Hand carry',
    hawalaDetails: 'Hawala details',
    hawalaCode: 'Hawala code',
    sarrafiSlip: 'Sarrafi slip',
    attachSlipPhoto: 'Attach slip photo',
    sendingInfo: 'Sending info',
    sendingSarrafi: 'Sending sarrafi',
    senderName: 'Sender name',
    phone: 'Phone',
    receivingInfo: 'Receiving info',
    payingSarrafiDest: 'Paying sarrafi (destination)',
    receiverName: 'Receiver name',
    whoCollectsCash: 'Who collects the cash',
    sarrafiCommission: 'Sarrafi commission',
    whoPaysCommission: 'Who pays the commission?',
    onTopOfAmount: 'On top of amount',
    deductedFromAmount: 'Deducted from amount',
    cashOutOf: 'Cash out of {name}',
    transferToDestination: 'Transfer to destination',
    commissionVoucher: 'Commission voucher',
    receiverCollects: 'Receiver collects',
    recordCommissionCheckbox: 'Record the commission as a payment voucher (Cheque) to Bank charges',
    handCarryDetails: 'Hand-carry details',
    carriedBy: 'Carried by',
    expectedArrival: 'Expected arrival',
    attachSignedNote: 'Attach the signed hand-over note',
    readyToSend: 'Ready to send',
    saveDraft: 'Save draft',
    reviewAndSend: 'Review & send',
    hawalaSent: 'Hawala sent',
    transferReceived: 'Transfer received',
    tracking: 'Tracking',
    stepRecordedInLedger: 'Recorded in the {name} cash ledger',
    stepWaitingForConfirm: 'Waiting for {name} to confirm receipt',
    stepReceivedAt: 'Received at {name}',
    stepReceiverCollects: '{name} collects from {sarrafi} with code {code}',
    stepQboTransfer: 'QuickBooks Transfer',
    stepQboRecorded: 'Transfer #1832 recorded in QBO',
    stepPostedAfterConfirm: 'Posted after receipt is confirmed',
    stepVoucherQueued: 'Queued for sync · Bank charges',
    confirmReceipt: 'Confirm receipt',
    copyForReceiver: 'Copy for receiver',
    copied: 'Copied ✓',
    newTransfer: 'New transfer',
    afterConfirmation: 'after confirmation'
  }
}